<template>
  <ModalDialog @close-modal="closeModal" open>
    <template v-slot:content>
      <div>
        <p>
          This action will send an email to the new OUDirect customer
          administrator at <b>{{ newWebContactEmail }}</b
          >.<br /><br />
          The former admin, <b>{{ oldWebContactEmail }}</b
          >, will no longer have access. <br /><br />Do you want to continue?
        </p>
        <div class="btns">
          <span class="btn confirm" @click="confirm">Yes</span>
          <span class="btn" @click="closeModal">No</span>
        </div>
      </div>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";

defineProps<{
  oldWebContactEmail: string;
  newWebContactEmail: string;
}>();

const emit = defineEmits<{
  (e: "closeModal"): void;
  (e: "confirm"): void;
}>();

function closeModal() {
  emit("closeModal");
}

function confirm() {
  emit("confirm");
  closeModal();
}
</script>

<style scoped>
dialog {
  width: 100%;
  height: 100%;
  top: 0;
  border: none;
  background: none;
}
dialog .modal-content {
  border: none;
  border-top: 7px solid #4a90e2;
  padding: 20px;
  width: 400px;
  left: 50%;
  margin-left: -200px;
  position: fixed;
  top: 15vh;
  background-color: white;
  box-shadow: 0 2px 8px rgbal(0, 0, 0, 0.26);
  z-index: 9999;
}
.btns {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.btn {
  font-size: 14px;
  padding: 8px;
  cursor: pointer;
  display: inline-block;
  border: 1px solid #3a5da6;
  width: 100px;
  border-radius: 4px;
  margin-right: 10px;
  text-align: center;
}
.btn.confirm {
  color: white;
  background: #3a5da6;
}
.btn.confirm:hover {
  background: #2d4880;
}
dialog .modal-bg {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
}
</style>
